import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { BASE_COLOR } from 'shared/constants/colors';
import { overlayOpenComposeEditor } from 'shared/actions/view/web';
import { compose } from 'shared/helpers';

import {
  SvgIcon,
  DiamondButton,
  NavLink,
} from 'components/elems';
import CurrentEntityOptionDropdown from './CurrentEntityOptionDropdown';


const PlusIcon = () => (
  <SvgIcon.strl.Add1F
    size={20}
    fill={BASE_COLOR.white}
  />
);


// TODO(tyu): Until we have real nav links

// const MainAppContentNavs = () => (
//   <div className="flex items-center">
//     <NavLink to="/today">
//       TODAY
//     </NavLink>
//   </div>
// );
// <MainAppContentNavs />

// <div className="flex items-center f3 black-10 ml4">
//   /
// </div>


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    overlayOpenComposeEditor,
  }, dispatch);
}



const CoreActionControlGroup = ({
  handle,
  ...props,
}) => {
  const pathToMyProfile = `/@${handle}`;

  return (
    <div className="flex">
      <div
        style={{minWidth: '246px'}}
        className="flex items-center justify-end pr4 pl3"
      >
        <NavLink to={pathToMyProfile} className="pv0 ph2">
          {handle}
        </NavLink>

        <div className="ml2">
          <CurrentEntityOptionDropdown />
        </div>
      </div>

      <DiamondButton
        icon={<PlusIcon />}
        outerStyle={{
          animation: 'DiamondButton-little-bounce 100ms forwards'
        }}
        color={BASE_COLOR.caretBlue}
        size={42}
        onClick={props.overlayOpenComposeEditor}
      />
    </div>
  );
};

// NOTE(t10u): {pure: false} option to ensure NavLink
// is being correctly updated when route changes.
// Reference:https://github.com/reactjs/react-redux/blob/master/docs/troubleshooting.md
export default compose(
  connect(null, mapDispatchToProps, null, {
    pure: false,
  }),
  // injectSheet(styles)
)(CoreActionControlGroup);



// WEBPACK FOOTER //
// ./src/components/navs/_navbar/CoreActionControlGroup.js